export default "__VITE_ASSET__BNrxN93i__"